import React from 'react';
import { Button } from '../../ui/button';
import { QrCode } from 'lucide-react';

interface QRCodeSetupProps {
  qrCodeUrl: string;
  error: string;
  onGenerateQRCode: () => Promise<void>;
  onNext: () => void;
}

export const QRCodeSetup: React.FC<QRCodeSetupProps> = ({
  qrCodeUrl,
  error,
  onGenerateQRCode,
  onNext
}) => {
  return (
    <div className="space-y-4 p-4 bg-gray-800/30 rounded-lg">
      <div className="space-y-2">
        <div className="text-sm font-medium text-white">1. Scan QR Code</div>
        <div className="text-sm text-gray-400">
          Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)
        </div>
      </div>
      
      {qrCodeUrl ? (
        <div className="flex justify-center p-4 bg-white rounded-lg">
          <img src={qrCodeUrl} alt="2FA QR Code" className="w-48 h-48" />
        </div>
      ) : (
        <div className="flex justify-center">
          <Button onClick={onGenerateQRCode}>
            <QrCode className="h-4 w-4 mr-2" />
            Generate QR Code
          </Button>
        </div>
      )}
      
      {error && (
        <div className="text-sm text-red-500 bg-red-500/10 px-4 py-2 rounded-lg">
          {error}
        </div>
      )}
      
      {qrCodeUrl && (
        <Button className="w-full" onClick={onNext}>
          Next
        </Button>
      )}
    </div>
  );
};